//@flow

import React from 'react';
import type { Node } from 'react';

type CardBodyBottomProps = { children: Node };

const CardBodyBottom = (props: CardBodyBottomProps) => (
  <div className="cardBodyBottom">{props.children}</div>
);

export default CardBodyBottom;



// WEBPACK FOOTER //
// ./src/components/Cards/Common/CardBodyBottom.jsx